import {Link as RouterLink} from 'react-router-dom';
import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Link = styled(RouterLink)`
    color: ${colors.brandPrimary};
    text-decoration: none;

    :hover {
        color: ${colors.brandDark};
    }
`;

export const LinkSmall = styled(Link)`
    font-size: 11px;
    font-weight: 500;
    line-height: 20px;
`;
